import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export default function PrivateRoute() {
  const { isAuth, mustChangePassword } = useAuth();
  const { pathname } = useLocation();

  if (!isAuth) return <Navigate to="/signin" replace />;
  if (mustChangePassword && pathname !== '/change-password')
    return <Navigate to="/change-password" replace />;

  return <Outlet />;
}
